module.exports = __webpack_public_path__ + "media/images/subject_img/CULTURAL STUDIES-29f07900766e881220fa4fb9649aab02.jpg";